import { render, staticRenderFns } from "./SaveMsgPopUp.vue?vue&type=template&id=2aeb6820"
import script from "./SaveMsgPopUp.vue?vue&type=script&lang=ts"
export * from "./SaveMsgPopUp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports